module.exports = __webpack_public_path__ + "static/media/findMediator.ae337355.jpg";